// extracted by mini-css-extract-plugin
export var phone = "_1q-0";
export var phoneDragging = "_1q-1";